<template>
    <form class="grid-cols-layout lg:grid" @submit.prevent="save">
        <div class="mb-6 lg:mb-0 lg:mt-4">
            <h3
                class="mb-[5px] text-lg font-medium leading-normal tracking-small text-gray-800"
            >
                Default fonts
            </h3>
            <p class="max-w-xs text-sm text-gray-500">
                You can define default fonts available in Topol editor.
            </p>
        </div>
        <div
            class="relative mx-auto w-full rounded-[6px] bg-white shadow-card lg:mx-0"
        >
            <div
                class="flex flex-wrap gap-2 border-b border-gray-200 px-6 py-5"
            >
                <FontComponent
                    v-for="font in defaultFonts"
                    :key="font.label"
                    :font="font"
                    :checked="
                        selectedFonts.find((f) => f.style === font.style) !==
                        undefined
                    "
                    @select-font="selectFont(font)"
                />
            </div>

            <div class="flex justify-end">
                <div class="my-3 pr-6">
                    <LockableButton
                        type="submit"
                        color="yellow"
                        size="sm"
                        :disabled="saveDisabled"
                        :locked="!hasAnyProSubscriptionOrTrial"
                        lock-message="You need a PRO subscription to update editor settings."
                    >
                        Save changes
                    </LockableButton>
                </div>
            </div>
        </div>
    </form>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import useFonts from '../composables/useFonts';
import IEditorSettings from '@/types/Settings/IEditorSettings';
import IFont from '@/types/Settings/IFont';

const props = defineProps({
    settings: {
        type: Object as PropType<IEditorSettings>,

        default: () => {},
    },
});

const emit = defineEmits(['save']);
const { hasAnyProSubscriptionOrTrial } = useSubscriptions();

const { loadExternalStylesheet, defaultFonts } = useFonts();

const selectedFonts = ref(
    props.settings.default_fonts.length > 0
        ? props.settings.default_fonts
        : defaultFonts
);

const saveDisabled = computed(() => {
    return (
        selectedFonts.value.length === 0 ||
        JSON.stringify(props.settings.default_fonts) ===
            JSON.stringify(selectedFonts.value) ||
        (selectedFonts.value.length >= 15 &&
            props.settings.default_fonts.length === 0)
    );
});
const selectFont = (font: IFont) => {
    const found = selectedFonts.value.find((f) => f.style === font.style);

    if (found) {
        selectedFonts.value = selectedFonts.value.filter(
            (f) => f.style !== font.style
        );
    } else {
        selectedFonts.value = [...selectedFonts.value, font];
    }
};

const save = () => {
    const fonts =
        selectedFonts.value.length > 0 && selectedFonts.value.length < 15
            ? selectedFonts.value
            : [];
    emit('save', fonts);
};

onBeforeMount(() => {
    const defaultFontUrls = defaultFonts
        .map((font) => font.url)
        .filter((url) => url !== undefined);

    defaultFontUrls.forEach((url) => loadExternalStylesheet(url as string));
});
</script>
